import TutorialContentItemImage from '../images/2.jpg';
import { React, useEffect, useState } from "react";
import { Link } from 'react-router-dom';

//repreater block
const TutorialContent = ({ TutorialContent }) => {

    const [modal, setModal] = useState(false);
    const [vedioPopup, setVedioPopup] = useState(true);
    const [videoLoading, setVideoLoading] = useState(true);

    const openModal = (vedioLink) => {
        setVedioPopup(vedioLink);
        setModal(!modal);
    };

    const closeModal = () => {
        setVedioPopup(null);
        setModal(false);
    };

    const spinner = () => {
        setVideoLoading(!videoLoading);
    };

    const handleScrollToLink = (target) => {
        const targetId = target.split('#')[1];
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // Function to render the appropriate link based on the tutorialGroup_link type
    const renderLink = (item) => {
        switch (item.tutorialGroup_link) {
            case 'tutorialGroup_link_href':
                return (
                    <Link to={`/${item.tutorialGroup_link_href}`} onClick={() => handleScrollToLink(item.tutorialGroup_link_href)}>
                        <div className="Tutorial-panel" key={item._key}>
                            <img className="img-fluid" src={item.imageUrl} alt={item.tutorialGroup_title} />
                            <div className='tutorialTitleWrapper'>
                                <h2 className="tutorial-name">{item.tutorialGroup_title} </h2>
                                <span className="arrow-right"></span>
                            </div>
                        </div>
                    </Link>
                );
            case 'tutorialGroup_link_url':
                return (
                    <Link to={item.tutorialGroup_link_url} target="_blank">
                        <div className="Tutorial-panel" key={item._key}>
                            <img className="img-fluid" src={item.imageUrl} alt={item.tutorialGroup_title} />
                            <div className='tutorialTitleWrapper'>
                                <h2 className="tutorial-name">{item.tutorialGroup_title} </h2>
                                <span className="arrow-right"></span>
                            </div>
                        </div>
                    </Link>
                );
            case 'tutorialGroup_link_video':
                return (
                    <div className="Tutorial-panel" key={item._key} onClick={() => openModal(item.tutorialGroup_link_video)}>
                        <img className="img-fluid" src={item.imageUrl} alt={item.tutorialGroup_title} />
                        <div className='tutorialTitleWrapper'>
                            <h2 className="tutorial-name">{item.tutorialGroup_title} </h2>
                            <span className="arrow-right"></span>
                        </div>
                    </div>

                );
            default:
                return null;
        }
    };


    return (
        <>
            <div className="process-panels-container tutorial-container">
                {Array.isArray(TutorialContent) && TutorialContent.slice(0, 3).map(renderLink)}
            </div>

            {modal ? (
                <div className="modal__bg">
                    <div className="overlay" >
                        <div className="modal__align">
                            <div className="modal__content" modal={modal}>

                                <div className="modal__video-align">
                                    <div className="modal__close" arial-label="Close modal" onClick={closeModal}>X</div>
                                    {videoLoading ? (
                                        <div className="modal__spinner">
                                        </div>
                                    ) : null}
                                    <iframe
                                        className="modal__video-style"
                                        onLoad={spinner}
                                        loading="lazy"
                                        width="800"
                                        height="500"
                                        src={vedioPopup}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            ) : null}

        </>
    );
}

export default TutorialContent;